'use client';

import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 1320px;
  gap: 16px;

  @media (max-width: 1320px) {
    max-width: 936px;
  }

  @media (max-width: 936px) {
    max-width: 618px;
  }
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 20px;
`;
